export default __webpack_public_path__ + "static/media/23.01905392.jpg";